import httpClient from '../config/httpClient';
import {
  subscribeToIntegrationImportLogs,
  getIntegrationImportLogDetails,
  subscribeToIntegrationStatus,
} from './integrationImport';

export const getSalesforceAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/salesforceGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectSalesforce = async (companyId, userId) => {
  const { data } = await httpClient.post('/salesforceDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getSalesforceContacts = async (companyId) => {
  const { data } = await httpClient.post('/salesforceGetContacts', {
    companyId,
  });
  return data;
};

export const autoMapSalesforceEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/salesforceAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const exportAllEmployeesToSalesforce = async (companyId, teamId) => {
  const { data } = await httpClient.post('/salesforceExportAllEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const createAndMapSalesforceEmployee = async (
  companyId,
  prodaffUserId,
  displayName,
  email
) => {
  const { data } = await httpClient.post('/salesforceCreateAndMapEmployee', {
    companyId,
    prodaffUserId,
    displayName,
    email,
  });
  return data;
};

export const saveSalesforceMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/salesforceSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncSalesforceTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/salesforceSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const importSalesforceEmployees = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/salesforceImportEmployees', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const previewSalesforceImport = async (companyId, teamId, userId) => {
  const { data } = await httpClient.post('/salesforcePreviewImport', {
    companyId,
    teamId,
    userId,
  });
  return data;
};

export const subscribeToSFImportLogs = (companyId, onUpdate) =>
  subscribeToIntegrationImportLogs(companyId, 'salesforce', onUpdate);

export const getSFImportLogDetails = (companyId, logId) =>
  getIntegrationImportLogDetails(companyId, 'salesforce', logId);

const DISCONNECTED_SF_STATUS = {
  connected: false,
  instanceUrl: null,
  connectedAt: null,
  connectedBy: null,
  employeeMappings: {},
  employeeMappingsUpdatedAt: null,
  lastSyncAt: null,
  lastSyncStats: null,
};

export const subscribeToSFStatus = (companyId, onUpdate) => {
  return subscribeToIntegrationStatus(
    companyId,
    'salesforce',
    ({ exists, data: d }) => {
      if (!exists || !d.connected) {
        onUpdate(DISCONNECTED_SF_STATUS);
        return;
      }
      onUpdate({
        connected: true,
        instanceUrl: d.instanceUrl || null,
        connectedAt: d.connectedAt ? new Date(d.connectedAt) : null,
        connectedBy: d.connectedBy || null,
        employeeMappings: d.employeeMappings || {},
        employeeMappingsUpdatedAt: d.employeeMappingsUpdatedAt
          ? new Date(d.employeeMappingsUpdatedAt)
          : null,
        lastSyncAt: d.lastSyncAt ? new Date(d.lastSyncAt) : null,
        lastSyncStats: d.lastSyncStats || null,
      });
    }
  );
};
